var stdin_default = function() {
  function t() {
    this.name = "zIndex";
  }
  return t.prototype.css = function(t2, e) {
    if (t2 && t2.length) {
      if (e) return t2.css("z-index", e);
    }
    return null;
  }, t.prototype.createTarget = function() {
    return this.target = hiprintJQuery(
      '<div class="hiprint-option-item">\n        <div class="hiprint-option-item-label">\n        \u5143\u7D20\u5C42\u7EA72\n        </div>\n        <div class="hiprint-option-item-field">\n        <input type="number" class="auto-submit"/>\n        </div>\n    </div>'
    ), this.target;
  }, t.prototype.getValue = function() {
    var t2 = this.target.find("input").val();
    if (t2) return parseInt(t2.toString());
  }, t.prototype.setValue = function(t2) {
    this.target.find("input").val(t2);
  }, t.prototype.destroy = function() {
    this.target.remove();
  }, t;
}();
export {
  stdin_default as default
};
